import React from "react";
import { Controller } from "react-hook-form";
import { Typography, Box } from "@mui/material";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { useTheme } from "@emotion/react";

function QuillComponent({
  control,
  name,
  label,
  readOnly,
  placeholder = "Enter description",
  toolbarOptions = [
    [{ font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
  ],
  ...props
}) {
  const modules = {
    toolbar: toolbarOptions,
  };
  const { isDarkMode } = useTheme();

  return (
    <Box {...props}>
      <Typography variant="subtitle1" gutterBottom className="text-rgba-gray">
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ReactQuill
            {...field}
            theme="snow"
            modules={modules}
            placeholder={placeholder}
            readOnly={readOnly}
            className={isDarkMode ? "quill-dark" : "quill-light"}
            style={{
              // backgroundColor: isDarkMode ? "white" : "black",
              color: isDarkMode ? "black" : "white",
              borderRadius: 4,
            }}
          />
        )}
      />
    </Box>
  );
}

export default QuillComponent;
